module.exports = "/packs/008-0e47b2eff21a7bb6ef7f1ecb71484f87.jpg";